import request from "@/utils/request";

export function getCreateModels(params) {
  return request({
    url: "/api/c/create/models",
    method: "get",
    params,
  });
}

export function createGenerateTask(data, options = {}) {
  return request({
    url: "/api/c/create/tasks",
    method: "post",
    data,
    timeout: options.timeout || 3 * 60 * 1000,
    silentError: true, // 由调用方（failNotify）统一处理错误展示
  });
}

export function getGenerateTask(taskId, options = {}) {
  return request({
    url: `/api/c/create/tasks/${encodeURIComponent(taskId)}`,
    method: "get",
    ...(options.baseURL ? { baseURL: options.baseURL } : {}),
    ...(options.timeout ? { timeout: options.timeout } : {}),
    silentError: !!options.silentError,
  });
}
